import React, { useEffect, useState } from 'react';
import { Grid, Dialog, DialogContent, DialogActions } from '@mui/material';
import { GradientColorHeader } from '@Local/Components/Dialog/';
import { Button, FormControlLabel, Switch, TextField } from '@curves/ui-base';

import useCustomerResourceApi from '@Apis/useCustomerResourceApi';
import { useCustomerResourceContext } from '@Local/CustomerResource/Components/CustomerResourceContext';
const CustomerResourceAddDialog = React.forwardRef((props, ref) => {
    const { open = false, onClose, sourceData } = props;
    const { postCustomerResourceApi, putCustomerResourceApi } = useCustomerResourceApi();
    const { refresh } = useCustomerResourceContext();
    const [formData, setFormData] = useState({
        sourceName: '',
        sourceNote: '',
        enabled: true
    });
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    useEffect(() => {
        if (open) {
            if (sourceData) {
                // 編輯
                setFormData({
                    sourceName: sourceData.sourceName || '',
                    sourceNote: sourceData.sourceNote || '',
                    enabled: sourceData.enabled !== undefined ? sourceData.enabled : true
                });
            } else {
                // 新增
                setFormData({
                    sourceName: '',
                    sourceNote: '',
                    enabled: true
                });
            }
            setErrors({});
        }
    }, [open, sourceData]);
    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
        // 清除該字段的錯誤
        if (errors[field]) {
            setErrors(prev => ({
                ...prev,
                [field]: ''
            }));
        }
    };
    const validateForm = () => {
        const newErrors = {};
        if (!formData.sourceName.trim()) {
            newErrors.sourceName = '項目名稱為必填欄位';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async () => {
        if (!validateForm()) {
            return;
        }
        setLoading(true);
        try {
            if (sourceData) {
                // 編輯
                await putCustomerResourceApi(sourceData.sourceID, formData);
            } else {
                // 新增
                await postCustomerResourceApi(formData);
            }         
            onClose();
            if (typeof refresh === 'function') {
                setTimeout(refresh, 300);
            }
        } catch (error) {
            console.error('保存失敗:', error);
        } finally {
            setLoading(false);
        }
    };
    const isEditMode = !!sourceData;
    const dialogTitle = isEditMode ? '編輯來源' : '新增來源';
    return (
        <Dialog open={open} maxWidth="sm" fullWidth>
            <GradientColorHeader onClose={onClose}>{dialogTitle}</GradientColorHeader>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid xs={12} item>
                        <TextField 
                            label="項目名稱" 
                            required 
                            value={formData.sourceName}
                            onChange={(e) => handleInputChange('sourceName', e.target.value)}
                            fullWidth
                        />
                    </Grid>
                    <Grid xs={12} item>
                        <TextField 
                            label="項目說明" 
                            minRows={3} 
                            multiline 
                            fullWidth
                            defaultValue={formData.sourceNote} // 預設說明defaultValue
                            onChange={(e) => handleInputChange('sourceNote', e.target.value)}
                        />
                    </Grid>
                    <Grid xs={12} item>
                        <FormControlLabel
                            className="m-0"
                            control={
                                <Switch 
                                    checked={formData.enabled}
                                    onChange={(e) => handleInputChange('enabled', e.target.checked)}
                                />
                            }
                            prefixLabel="是否生效"
                            labelPlacement="start"
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button 
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    disabled={loading}
                >
                    {loading ? '處理中...' : (isEditMode ? '更新' : '新增')}
                </Button>
            </DialogActions>
        </Dialog>
    );
});
CustomerResourceAddDialog.displayName = 'CustomerResourceAddDialog';
export default CustomerResourceAddDialog;
